import React from 'react';
import classNames from 'classnames';

export default function TitleField({
  id,
  title,
  useHeaderStyling,
  forceDivWrapper,
}) {
  const isRoot = id === 'root__title';
  const classes = classNames('schemaform-block-title', {
    'schemaform-block-subtitle': !isRoot,
  });

  const isEmptyTitle = typeof title === 'string' && title.trim() === '';
  if (!title || isEmptyTitle) return null;

  // Render the title as a heading when there is no fieldset (forceDivWrapper)
  // or when the caller opts into header styling. The element is always an <h3>
  // for a consistent heading level; useHeaderStyling only sets the visual size.
  if (forceDivWrapper || useHeaderStyling) {
    // Font-size token: an explicit level string, 'h5' for the boolean opt-in,
    // otherwise 'h3'.
    let fontSize = 'h3';
    if (typeof useHeaderStyling === 'string') {
      fontSize = useHeaderStyling;
    } else if (useHeaderStyling) {
      fontSize = 'h5';
    }
    const heading = (
      <h3 className={`vads-u-font-size--${fontSize}`} id={id}>
        {title}
      </h3>
    );
    // A <legend> is only valid inside a <fieldset>; forceDivWrapper has none.
    return forceDivWrapper ? (
      heading
    ) : (
      <legend className={classes}>{heading}</legend>
    );
  }

  return (
    <legend className={classes} id={id}>
      {title}
    </legend>
  );
}
